import { render, staticRenderFns } from "./attack-center.vue?vue&type=template&id=705d72a1&scoped=true&"
import script from "./attack-center.vue?vue&type=script&lang=js&"
export * from "./attack-center.vue?vue&type=script&lang=js&"
import style0 from "./attack-center.vue?vue&type=style&index=0&id=705d72a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d72a1",
  null
  
)

export default component.exports